import { Box } from '@mui/material';

import { useMediaDevicesContext } from '../../providers/media-devices-context';
import ZaraAvatar from '../zara-avatar/zara-avatar';

export const ZaraPreview = ({
  size = 200,
  pointSize = 2,
}: {
  size?: number;
  pointSize?: number;
}) => {
  const { analyser } = useMediaDevicesContext();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box
        sx={{ width: `${size}px`, height: `${size}px`, position: 'relative' }}
      >
        <ZaraAvatar
          isAiSpeaking={false}
          avServiceAnalyser={analyser}
          isLoading={false}
          size={size}
          pointSize={pointSize}
        />
      </Box>
    </Box>
  );
};
